@if (createTS()) {
    <div class="history-wrap">
        <p >Aangemaakt op {{createTS() | formatTs: format() }} <span *ngIf="createUsername()">door {{createUsername()}}</span></p>
        @if (editTS()) {
            <p>Gewijzigd op {{editTS() | formatTs: format() }} <span *ngIf="editUsername()">door {{editUsername()}}</span></p>
        }
    </div>
}